module.exports = __webpack_public_path__ + "80dabc15db97759e9c20450d993cc8aa.svg";